<!-- 项目子项 -->
<template>
  <container-wrapper v-if="!isRuntime" :designer="designer" :widget="field" :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList">
    <div class="table-container" :class="[selected ? 'selected' : '', customClass]" @click.stop="selectWidget(field)">
      <preview-table :widget="field"> </preview-table>
    </div>
  </container-wrapper>
  <itemTable
    v-else-if="isRuntime && !field.options.hidden"
    ref="itemTable"
    :designer="designer"
    :widget="field"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
  ></itemTable>
  <div v-else></div>
</template>

<script>
import previewTable from "./preview.vue";
import itemTable from "./item.vue";
import { VFormSDK } from "@/CommonDP/lib/vform/VFormDesigner.umd.min.js";
const { containerMixin, i18n, ContainerWrapper, emitter, refMixinDesign, refMixin } = VFormSDK;

export default {
  name: "JyhtTableWidget",
  componentName: "ContainerWidget",
  components: {
    ContainerWrapper,
    previewTable,
    itemTable
  },
  mixins: [emitter, containerMixin, i18n, refMixinDesign, refMixin],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },

  inject: ["refList", "globalOptionData", "globalModel"],
  data() {
    return {
      designState: true
    };
  },
  computed: {
    isRuntime() {
      return !this.designer;
    },
    widget() {
      return this.field;
    },
    selected() {
      return this.field.id === this.designer.selectedId;
    },
    customClass() {
      return this.field.options.customClass || "";
    }
  },

  created() {
    this.initRefList();
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.width-full {
  display: block;
}
.readonly-mode {
  width: 100%;
  display: inline-block;
  white-space: pre-wrap;
  line-height: 1.5;
  color: #c0c4cc;
}
div.table-container {
  padding: 5px;
  // border: 1px dashed #336699;
  box-sizing: border-box;
}
.table-container.selected {
  outline: 2px solid #409eff !important;
}
</style>
